import React, { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
} from "recharts";
import { useSelector } from "react-redux";
import { getAllProject } from "../../api/projectManagement";
import {
  getProjectBudgetVsActual,
  getTaskPriorityGraph,
  getTaskStatusGraph,
  getTaskTimelineChart,
} from "../../api/projectManagement";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@material-ui/core";
import RadialProgressChart from "../../component/RadialProgressChart";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0];
    return (
      <div className="bg-black text-white text-xs px-3 py-1 rounded shadow-lg">
        <strong>{name}</strong>: {value}
      </div>
    );
  }
  return null;
};
const ProjectDashboard = ({allTasks,getPorojectCompletionPercent}) => {
    const params = useParams();
  const  user= useSelector((state) => state.user);
  const [hoveredTask, setHoveredTask] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState("all");
  const [sortType, setSortType] = useState("start");
  const [projects, setProjects] = useState([]);
  // const [params?.id, setparams?.id] = useState("");
  const [taskStatusData, setTaskStatusData] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [taskPriorityData, setTaskPriorityData] = useState([]);
  const [budgetData, setBudgetVsActualData] = useState([]);
  const [taskTimelineData, setTaskTimelineData] = useState([]);

  const months = Array.from(
    new Set(
      taskTimelineData.map((task) =>
        new Date(task.start).toLocaleString("en-US", {
          month: "long",
          year: "numeric",
        })
      )
    )
  );

  let filteredTasks =
    selectedMonth === "all"
      ? taskTimelineData
      : taskTimelineData.filter(
          (task) =>
            new Date(task.start).toLocaleString("en-US", {
              month: "long",
              year: "numeric",
            }) === selectedMonth
        );

  if (sortType === "progress") {
    filteredTasks = [...filteredTasks].sort((a, b) => b.progress - a.progress);
  } else {
    filteredTasks = [...filteredTasks].sort(
      (a, b) => new Date(a.start) - new Date(b.start)
    );
  }

  const projectStart = new Date(
    Math.min(...filteredTasks.map((task) => new Date(task.start)))
  );
  const projectEnd = new Date(
    Math.max(...filteredTasks.map((task) => new Date(task.end)))
  );

  const totalDays = Math.ceil(
    (projectEnd - projectStart) / (1000 * 60 * 60 * 24)
  );

  const generateDateHeaders = () => {
    const headers = [];
    const current = new Date(projectStart);
    while (current <= projectEnd) {
      headers.push(new Date(current));
      current.setDate(current.getDate() + 7); // Weekly
    }
    return headers;
  };

  const dateHeaders = generateDateHeaders();

  const getTaskPosition = (task) => {
    const startDate = new Date(task.start);
    const endDate = new Date(task.end);
    const startDays = Math.ceil(
      (startDate - projectStart) / (1000 * 60 * 60 * 24)
    );
    const duration = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    return {
      left: (startDays / totalDays) * 100,
      width: (duration / totalDays) * 100,
    };
  };

  //   const getProgressColor = (progress) => {
  //     if (progress === 100) return "bg-green-600";
  //     if (progress >= 80) return "bg-green-500";
  //     if (progress >= 60) return "bg-green-400";
  //     if (progress >= 40) return "bg-lime-400";
  //     if (progress >= 20) return "bg-yellow-400";
  //     if (progress > 0) return "bg-orange-400";
  //     return "bg-gray-400";
  //   };

  //   const overallProgress =
  //     filteredTasks.length > 0
  //       ? Math.round(
  //           filteredTasks.reduce((sum, task) => sum + task.progress, 0) /
  //             filteredTasks.length
  //         )
  //       : 0;

  const COLORS = [
    "#00BCD4",
    "#8BC34A",
    "#FFC107",
    "#FF5722",
    "#E91E63",
    "#FF9800",
    "#4CAF50",
  ];

  const fetchProjects = async () => {
    try {
      const { data } = await getAllProject(user.token, {});
      setProjects(data?.data?.projects || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  const fetchProjectTask = async () => {
    try {
      const { data } = await getTaskStatusGraph(user.token, params?.id);
      const taskStatus = data?.data?.map((item) => {
        return { value: parseFloat(item.count), name: item.status };
      });
      setTaskStatusData(taskStatus || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  const getTaskPriority = async () => {
    try {
      const { data } = await getTaskPriorityGraph(user.token, params?.id);
      const taskPriority = data?.data?.map((item) => {
        return { value: parseFloat(item.count), name: item.priority };
      });
      setTaskPriorityData(taskPriority || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  const getProjectBudget = async () => {
    try {
      const { data } = await getProjectBudgetVsActual(user.token, params?.id);

      setBudgetVsActualData(
        [
          {
            Amount: parseFloat(data?.data[0]?.budgeted || "0"),
            name: "Budgeted",
          },
          {
            Amount: parseFloat(data?.data[0]?.spent || "0"),
            name: "Spent",
          },
        ] || []
      );
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  const getTaskTimeline = async () => {
    try {
      const { data } = await getTaskTimelineChart(user.token, params?.id);

      setTaskTimelineData(data?.tasks || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  useMemo(() => {
    fetchProjects();
  }, [user.token]);
  useEffect(() => {
    if (params?.id) {
      fetchProjectTask();
      getTaskPriority();
      getProjectBudget();
      getTaskTimeline();
    }
  }, [params?.id]);
  return (
    <div className="" style={{zoom:"0.75"}}>
      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          📊 Project Dashboard
        </h2>
        {/* <div>
          <label className="block mb-2.5 font-medium text-[#4A4A4A] text-[14px] capitalize group-hover:text-[#283453] transition-colors duration-200">
            Select Project
          </label>
          <select
            // disabled={type === "edit"?true:false}
            name="project_id"
            value={params?.id}
            onChange={(e) => setparams?.id(e.target.value)}
            required
            className="w-full h-[42px] rounded-[10px] border-none bg-[#fff] px-5 text-[14px] py-2 font-normal text-[#4A4A4A] outline-none focus:ring-2 focus:ring-[#283453] hover:ring-2 hover:ring-[#283453] transition-all duration-200 shadow-[0_2px_8px_-3px_rgba(108,30,132,0.12)] hover:shadow-[0_4px_12px_-3px_rgba(108,30,132,0.16)]"
          >
            <option value="">Select Project</option>
            {projects.map((project) => (
              <option key={project.project_id} value={project.project_id}>
                {project.project_name}
              </option>
            ))}
          </select>
        </div> */}
      </div>

      {/* Main Timeline Box */}

      {params?.id ? (
        <div className="bg-white border rounded-xl shadow p-6 " >
          {/* Timeline Headers */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="font-semibold text-center text-gray-700 mb-2 px-[10px]">
              Task Timeline
            </h2>
            <div className="flex gap-4 items-center">
              <div>
                <label className="text-sm text-gray-600 mr-1">Month:</label>
                <select
                  className="border border-gray-300 px-3 py-1.5 rounded text-sm focus:ring-2 focus:ring-blue-400"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="all">All</option>
                  {months.map((month, idx) => (
                    <option key={idx} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="text-sm text-gray-600 mr-1">Sort:</label>
                <select
                  className="border border-gray-300 px-3 py-1.5 rounded text-sm focus:ring-2 focus:ring-blue-400"
                  value={sortType}
                  onChange={(e) => setSortType(e.target.value)}
                >
                  <option value="start">Start Date</option>
                  <option value="progress">Progress</option>
                </select>
              </div>
            </div>
          </div>
          <div className="flex mb-4">
            <div className="w-[350px]"></div>
            <div className="flex-1 flex">
              {dateHeaders.map((date, index) => (
                <div
                  key={index}
                  className="flex-1 text-center text-xs text-gray-500 font-medium"
                >
                  {date.toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                  })}
                </div>
              ))}
            </div>
          </div>

          {/* Timeline Grid */}
          <div className="relative">
            <div className="absolute inset-0 flex">
              <div className="w-[350px]"></div>
              <div className="flex-1 flex">
                {dateHeaders.map((_, index) => (
                  <div
                    key={index}
                    className="flex-1 border-l border-gray-200"
                  ></div>
                ))}
              </div>
            </div>

            {/* Task Bars */}
            <div className="relative space-y-3">
              {filteredTasks.map((task, i) => {
                const position = getTaskPosition(task);
                return (
                  <div key={task.id} className="flex items-center h-10 group">
                    <div className="w-[350px] text-sm text-gray-700 text-right pr-3">
                      {task.name}
                    </div>
                    <div className="flex-1 relative">
                      <motion.div
                        className={`absolute top-2 h-4 rounded transition-all shadow`}
                        style={{
                          left: `${position.left}%`,
                          width: `${position.width}%`,
                          background: `${COLORS[i % COLORS.length]}`,
                        }}
                        onMouseEnter={() => setHoveredTask(task)}
                        onMouseLeave={() => setHoveredTask(null)}
                        layout
                      >
                        <div
                          className="h-full bg-black bg-opacity-20 rounded"
                          style={{
                            width: `${100}%`,
                            //   marginLeft: `${100}%`,
                          }}
                        ></div>
                      </motion.div>

                      <AnimatePresence>
                        {hoveredTask?.id === task.id && (
                          <motion.div
                            className="absolute top-10 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs px-3 py-2 rounded-lg shadow-lg z-20 whitespace-nowrap"
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -5 }}
                          >
                            <div className="font-semibold">{task.name}</div>
                            {/* <div>📈 {task.progress}%</div> */}
                            <div>
                              📅 {new Date(task.start).toLocaleDateString()}
                            </div>
                            <div>
                              🚩 {new Date(task.end).toLocaleDateString()}
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Overall Progress */}
          <div className="flex w-[100%] p-3 items-center mt-6">
            {/* <div className="mt-6 flex items-center space-x-3 w-full">
            <div className="text-sm text-gray-600 font-medium">
              Overall Progress:
            </div>
            <div className="w-full max-w-sm bg-gray-200 rounded-full h-3 overflow-hidden">
              <div
                className="h-full bg-blue-500 rounded-full transition-all"
                style={{ width: `${overallProgress}%` }}
              ></div>
            </div>
            <div className="text-sm font-semibold text-blue-600">
              {overallProgress}%
            </div>
          </div> */}
            {/* Legend */}
          </div>

          {/* Additional Charts Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-10">
            {/* Task Status */}
            <div className="bg-white shadow rounded-xl p-4">
              <h3 className="font-semibold text-center text-gray-700 mb-2">
                TASK STATUS %
              </h3>
              <PieChart width={320} height={320}>
                <Pie
                  data={taskStatusData}
                  cx="50%"
                  cy="50%"
                  outerRadius={70}
                  label
                  onMouseEnter={(_, index) => setActiveIndex(index)}
                  onMouseLeave={() => setActiveIndex(null)}
                >
                  {taskStatusData.map((entry, index) => (
                    <Cell
                      key={`status-${index}`}
                      fill={COLORS[index % COLORS.length]}
                      stroke={activeIndex === index ? "#000" : "#fff"}
                      strokeWidth={activeIndex === index ? 3 : 1}
                    />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
                <Legend />
              </PieChart>
            </div>

            {/* Task Priority */}

            <div className="bg-white shadow rounded-xl p-4 relative">
             <Box height={350}>
                                 <Typography
                                   textAlign="center"
                                   className="pmt-heading"
                                   variant="h2"
                                   p={1}
                                 >
                                   Project Completion
                                 </Typography>
                                 <RadialProgressChart
                                   label={`Progress ${parseInt(
                                     getPorojectCompletionPercent(allTasks)
                                   )}%`}
                                   value={parseInt(getPorojectCompletionPercent(allTasks))}
                                 />
                                 <br />
                               </Box>
            </div>

            {/* Budget */}
            <div className="bg-white shadow rounded-xl p-4 col-span-2">
              <h3 className="font-semibold text-center text-gray-700 mb-2">
                BUDGET
              </h3>
              <div className="flex justify-center items-center !h-[100%] item-center w-full bar-chart-container">
                <BarChart
                  layout="vertical"
                  width={430}
                  height={280}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  data={budgetData}
                >
                  <XAxis type="number" />
                  <YAxis type="category" dataKey="name" />
                  <Tooltip
                    formatter={(value, name) => [
                      parseFloat(value).toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      }),
                      name,
                    ]}
                  />
                  <Bar dataKey="Amount" fill="#4CAF50" />
                </BarChart>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-white border rounded-xl shadow p-6">
        <div className="flex items-center text-gray-500 text-sm italic space-x-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
          <span>Please select a project to view the details.</span>
        </div>
        </div>
      )}
    </div>
  );
};

export default ProjectDashboard;
